
import { Component, Prop, Vue } from 'vue-property-decorator';
import { links } from '@/configs/links';

@Component
export default class DescriptionBlockV extends Vue {
    @Prop() path!: string;

    links = links;
}
